<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-movimentacao-coluna"
      scrollable
      centered
      button-size="sm"
      v-on:hide="hideModal"
      v-on:close="hideModal"
    >
      <template #modal-title>
        <i class="fas fa-random"></i>&nbsp; MOVIMENTAÇÃO COLUNA
      </template>
      <h5>REGRAS CRIADAS</h5>
      <div
        class="table-responsive pt-2"
        v-if="rules && rules.length"
      >
        <table
          class="table table-hover"
          style="border: 1px solid #dcdede"
        >
          <thead
            class="thead-third"
            style="border: solid 1px #04a791"
          >
            <tr>
              <th
                class="text-center"
                style="font-size: 14px"
              >
                TIPO
              </th>
              <th
                class="text-center"
                style="font-size: 14px"
              >
                TEMPO
              </th>
              <th
                class="text-center"
                style="font-size: 14px"
              >
                ETAPA A MOVER
              </th>
              <th
                class="text-center"
                style="font-size: 14px"
              >
                AÇÕES
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(obj, index) in rules"
              :key="index"
            >
              <td
                class="text-center"
                :style="getTextStyle(obj.inative)"
              >
                {{ obj.tipoRegra }}
              </td>
              <td
                class="text-center"
                :style="getTextStyle(obj.inative)"
              >
                {{ formatTempo(obj) }}
              </td>
              <td
                class="text-center"
                :style="getTextStyle(obj.inative)"
              >
                {{ obj.boardColumn.nome }}
              </td>
              <td
                class="text-center"
                style="font-size: 16px; cursor: pointer"
              >
                <i
                  @click="onEdit(obj)"
                  class="fas fa-edit mr-1 text-third"
                ></i>
                <i
                  @click="toggleInative(obj)"
                  class="ml-1"
                  :class="
                    obj.inative
                      ? 'fas fa-check text-success'
                      : 'fas fa-ban text-danger'
                  "
                  v-b-tooltip.hover
                  :title="
                    obj.inative ? 'Clique para ativar' : 'Clique para inativar'
                  "
                >
                </i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        Nenhum registro de regra,
        <strong
          @click="openNewRuleModal"
          style="cursor: pointer"
          >clique para adicionar</strong
        >
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn rounded btn-third btn-sm"
            v-on:click="openNewRuleModal"
            v-b-tooltip.hover
            title="Clique para adicionar uma nova regra"
          >
            <i class="fa fa-plus mr-1"></i>
            <span class="d-md-down-none">Nova Regra</span></button
          >&nbsp;
        </div>
      </template>
    </b-modal>
    <ModalNewRule
      v-if="newRuleModalOpen"
      ref="ModalNewRule"
      :isEditing="isEditing"
      :column="columnObj"
      :index="index"
      v-on:Reload="updateAndClose"
      v-on:HideModal="closeNewRuleModal"
    />
  </div>
</template>
<script>
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import MovAutoCardRepository from '@/shared/http/repositories/crm/movimentacaoAutoCard.js'

import { toast } from '@/shared/utils/UIHelper'
import columnRuleTypes from '@/views/private/crm/board/modal/collumns/movimentacao-coluna/enumTiposRegra.js'
import ModalNewRule from '@/views/private/crm/board/modal/collumns/movimentacao-coluna/ModalNewRule.vue'

export default {
  name: 'ModalMovimentacaoColuna',
  props: {
    board: {
      type: Number,
      required: true
    },
    column: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      rules: [],
      ruleTypes: columnRuleTypes,
      newRuleModalOpen: false,
      isEditing: null,
      columnObj: null
    }
  },
  components: { ModalNewRule },
  created () {},
  mounted () {
    this.onLoadColumnRules()
    this.showModal()
  },
  methods: {
    showModal () {
      this.$refs['modal-movimentacao-coluna'].show()
    },
    hideModal () {
      this.$emit('Reload')
    },
    onEdit (obj) {
      this.isEditing = obj
      this.openNewRuleModal()
    },
    toggleInative (obj) {
      let id = obj.id
      let type
      switch (obj.tipoRegra) {
        case this.ruleTypes.TEMPO:
          type = 1
          break
        case this.ruleTypes.DIAS:
          type = 0
          break
      }
      let data = {}
      data.id = obj.id
      data.horas = obj.tempoAtraso
      data.boardColumnDestino = obj.boardColumn.id
      data.tipoRegra = type
      data.inative = !obj.inative

      MovAutoCardRepository.ChangeStatus(id, data)
        .then(() => {
          let message = !obj.inative
            ? 'Regra inativada com sucesso!'
            : 'Regra ativada com sucesso!'
          toast.success(message, 'Parabéns')
        })
        .catch((e) => {
          toast.error('Não foi possível realizar a alteração.', 'Desculpe')
          console.error(e)
        })
        .finally(() => {
          this.hideModal()
        })
      this.$emit('onSaveBoardColumn')
    },
    openNewRuleModal () {
      this.newRuleModalOpen = true
    },
    closeNewRuleModal () {
      this.newRuleModalOpen = false
      this.isEditing = null
      this.onLoadColumnRules()
    },
    updateAndClose () {
      this.newRuleModalOpen = false
      this.isEditing = null
      this.$emit('Update')
    },
    onLoadColumnRules () {
      this.onLoadColumn(this.board, this.column)
    },
    onLoadColumn (boardId, boardColumnId) {
      this.clearRules()
      BoardRepositoryV2.Column_GetById(boardId, boardColumnId)
        .then((res) => {
          this.columnObj = res.data
          if (this.columnObj && this.columnObj.movimentacaoAutoAtrasoProduto) {
            this.formatRulesRangeProduct(
              this.columnObj.movimentacaoAutoAtrasoProduto
            )
          }
          if (this.columnObj && this.columnObj.movimentacaoAutoDiaProduto) {
            this.formatRulesSpecificProduct(
              this.columnObj.movimentacaoAutoDiaProduto
            )
          }
          if (
            this.columnObj &&
            this.columnObj.movimentacaoAutoTempoBoardColumn
          ) {
            this.formatRuleTime(this.columnObj.movimentacaoAutoTempoBoardColumn)
          }
        })
        .catch((e) => {
          console.error(e)
          toast.error(
            'Não foi possível carregar as informações da coluna.',
            'Desculpe'
          )
        })
    },
    formatTempo (obj) {
      switch (obj.tipoRegra) {
        case this.ruleTypes.TEMPO:
          return `${obj.tempoAtraso} horas`
        case this.ruleTypes.DIAS:
          return `${this.hoursToDays(obj.tempoAtraso)} dias`
        case this.ruleTypes.DIA_ESPECIFICO:
          return ` dia ${this.hoursToDays(obj.tempoAtraso)}`
        default:
          return obj.tempoAtraso
      }
    },
    formatRulesRangeProduct (rules) {
      rules.forEach((rule) => {
        this.rules.push({
          tipoRegra: this.ruleTypes.DIAS,
          tempoAtraso: rule.horas,
          inative: rule.inative,
          boardColumn: {
            nome: rule.boardColumnDestino.nome,
            id: rule.boardColumnDestino.id
          },
          id: rule.id
        })
      })
    },
    clearRules () {
      this.rules = []
    },
    formatRulesSpecificProduct (rules) {
      rules.forEach((rule) => {
        this.rules.push({
          tipoRegra: this.ruleTypes.DIA_ESPECIFICO,
          tempoAtraso: rule.horas,
          inative: rule.inative,
          boardColumn: {
            nome: rule.boardColumnDestino.nome,
            id: rule.boardColumnDestino.id
          },
          id: rule.id
        })
      })
    },
    formatRuleTime (rule) {
      if (rule) {
        this.rules.push({
          tipoRegra: this.ruleTypes.TEMPO,
          tempoAtraso: rule.horas,
          inative: rule.inative,
          boardColumn: {
            nome: rule.boardColumnDestino.nome,
            id: rule.boardColumnDestino.id
          },
          id: rule.id
        })
      }
    },
    hoursToDays (time) {
      return parseInt(time / 24)
    },
    getTextStyle (inative) {
      return inative ? { color: '#818181', opacity: 0.5 } : {}
    }
  }
}
</script>
  <style lang="scss">
.formulate-input-element.formulate-input-element--textarea {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/collumns/movimentacao-coluna/ModalMovimentacaoColuna.vue